import { dangerAlert } from '../Shared/AlertHelper';
import { onloadTracking } from './Tracking/checkoutTrackingStep3';
import { CheckoutService } from './checkoutService';
import IBillingAddress = CheckoutflowRequest.IBillingAddress;
import IShippingAddress = CheckoutflowRequest.IShippingAddress;
import IPaymentMethodChange = CheckoutflowRequest.IPaymentMethodChange;
import ICart = CheckoutflowReponse.ICart;
import { trackPrefixNameProblem } from '../Tracking/GoogleTracking';
import { applyLeitwegIdState, isPublicAuthoritySelected } from '../Shared/leitwegIdToggle';
const checkoutService = new CheckoutService();
const step1ContentContainer: JQuery = $('#step1ContentContainer');
const step2ContentContainer: JQuery = $('#step2ContentContainer');
const spinner: JQuery = $('.checkoutSpinner');
let isGuestUser: boolean = window.location.search.indexOf('isGuestOrder') > -1;
declare var Cookies: any;
var submitOngoing = false;

$(() => {
    let cart: ICart = JSON.parse(localStorage.getItem('currentCart')) as ICart;

    if (window.location.search.indexOf('step2') !== -1) {
        onloadTracking(cart, '4_Zahlarten', 4);
    } else if (
        window.location.search.indexOf('isGuestOrder') !== -1 ||
        window.location.search.indexOf('isNewCustomer') !== -1
    ) {
        onloadTracking(cart, '3_Adressdaten');
    }

    $('.checkout_step_3_1_submit').on('click', function() {
        let formContainerId = $('#formRechnungsadresse input[name=optradiorechnungsadresse]:checked').attr(
            'data-targetShow'
        );
        let formBillingAddress = $(formContainerId).find('form');

        let formEmail = $(step1ContentContainer).find('.email_Form');
        let formShippingAddress = getShippingAddressForm();
        let shippingIsBilling: boolean =
            step1ContentContainer.find('#radio_SetShippingAddressAsBillingAddress:checked').length > 0;
        let isBillingAddressValid = formBillingAddress.valid();
        let isEmailValid = isGuestUser && formEmail.length > 0 ? formEmail.valid() : false;
        let isShippingAddressValid = formShippingAddress.length > 0 ? formShippingAddress.valid() : shippingIsBilling;

        if (formShippingAddress.length <= 0 && !shippingIsBilling) {
            dangerAlert('Sie müssen eine Lieferadresse auswählen.');
        }

        const middleName = $(formBillingAddress)
            .find('#MiddleName')
            .val();
        const lastName = $(formBillingAddress)
            .find('#LastName')
            .val();

        if (middleName && !lastName) {
            trackPrefixNameProblem();
        }

        if (!isBillingAddressValid || (!isEmailValid && isGuestUser) || !isShippingAddressValid) {
            const errorInputFields = $('.input-validation-error');
            errorInputFields.attr('aria-invalid', 'true');
            scrollToFirstError();
            errorInputFields.first().trigger('focus');
            return;
        }

        step1ContentContainer.slideUp('fast', function() {
            step1ContentContainer.next().hide();
            spinner.removeClass('hide');
        });

        let billingAddress: IBillingAddress = fillAddress(formBillingAddress);
        let emailAdress: string = isGuestUser ? (formEmail.find('.input_Email').val() as string) : null;
        let shippingAddress: IShippingAddress = fillAddress(formShippingAddress);

        addAddressesToCart(billingAddress, shippingAddress, emailAdress, shippingIsBilling, isGuestUser);
    });

    $('.checkout_step_3_2_submit').on('click', function() {
        Cookies.set('neworguest', 'true');
        Cookies.set('visitedStep3', 'true');

        let formSepa = getSepaForm();
        let isPayPalSelected: boolean = step2ContentContainer.find('#radio_paypal:checked').length > 0;
        let isInvoiceSelected: boolean = step2ContentContainer.find('#radio_Invoice:checked').length > 0;
        let isApplePaySelected: boolean = step2ContentContainer.find('#radio_applepay:checked').length > 0;
        let isGooglePaySelected: boolean = step2ContentContainer.find('#radio_googlepay:checked').length > 0;
        let isSepaValid = formSepa.length > 0 ? formSepa.valid() : false;
        let isDataUsageAccepted: boolean = step2ContentContainer.find('#DataUsageAccepted:checked').length > 0;
        if (!isSepaValid && !isPayPalSelected && !isInvoiceSelected && !isApplePaySelected && !isGooglePaySelected) {
            scrollToFirstError();
            return;
        }

        let paymentMethodChange: IPaymentMethodChange = CreatePaymentmethodChange();
        if (isPayPalSelected) {
            paymentMethodChange.type = 'PayPal';
        } else if (isInvoiceSelected) {
            paymentMethodChange.type = 'Invoice';
        } else if (isApplePaySelected) {
            paymentMethodChange.type = 'ApplePay';
        } else if (isGooglePaySelected) {
            paymentMethodChange.type = 'GooglePay';
        } else {
            paymentMethodChange = fillPaymentMethodSepa(paymentMethodChange, formSepa);
            if (!isDataUsageAccepted) {
                $('#dataUsageError').removeClass('hide');
                scrollToFirstError();
                return;
            }
        }

        step2ContentContainer.slideUp('fast', function() {
            spinner.removeClass('hide');
            step2ContentContainer.next().hide();
        });
        addPaymentmethodToCart(paymentMethodChange, isDataUsageAccepted, isGuestUser);
    });
    registerEvents();

    if ($('#requestFailed').val()) {
        dangerAlert($('#requestFailed').val());
    }

    $(document.body).on('change', '#rechnungsadressePrivatForm .input_FirstName', function() {
        $('#packstationForm .input_FirstName').val($(this).val());
        $('#postfilialePrivatForm .input_FirstName').val($(this).val());
    });

    $(document.body).on('change', '#rechnungsadressePrivatForm .input_LastName', function() {
        $('#packstationForm .input_LastName').val($(this).val());
        $('#postfilialePrivatForm .input_LastName').val($(this).val());
    });

    $(document.body).on('change', '#rechnungsadressePrivatForm .input_Salutation', function() {
        $('#packstationForm .input_Salutation').val($(this).val());
        $('#postfilialePrivatForm .input_Salutation').val($(this).val());
    });

    prefillDeliveryPostAddresses();
});

function prefillDeliveryPostAddresses() {
    if (window.location.search.indexOf('isNewCustomer') !== -1) {
        $('#packstationForm .input_FirstName').val($('#FirstName').val());
        $('#postfilialePrivatForm .input_FirstName').val($('#FirstName').val());

        $('#packstationForm .input_LastName').val($('#LastName').val());
        $('#postfilialePrivatForm .input_LastName').val($('#LastName').val());

        $('#packstationForm .input_Salutation').val($('#Salutation').val());
        $('#postfilialePrivatForm .input_Salutation').val($('#Salutation').val());
    }
}

function getShippingAddressForm(): JQuery {
    let checkedElement = step1ContentContainer.find('input[type=radio][name=lieferadresse]:checked');
    let targetId = checkedElement.parents('.lieferadressen_area').attr('data-target');
    let shippingAddressContainer = $(targetId);
    if (targetId == '#formPackstation') {
        return shippingAddressContainer.find('form');
    }
    let formShippingAddressId = shippingAddressContainer.find('.radioButtonAddress:checked').attr('data-targetShow');
    let formShippingAddress = $(formShippingAddressId).find('form');
    return formShippingAddress;
}

function getSepaForm(): JQuery {
    let checkedElement = step2ContentContainer.find('input[type=radio][name=zahlungsweise]:checked');
    let targetId = checkedElement.parents('.zahlungsweisen_area').attr('data-target');
    return $(targetId).find('form');
}

function scrollToFirstError() {
    var filledValidationErrors = $('.validationMessage').filter(function() {
        return /.*\S.*/.test($(this).text());
    });
    scrollTo(filledValidationErrors);
}

function fillAddress(form: JQuery) {
    if (!form || form.length == 0) {
        return null;
    }
    return {
        addressClassification: form.find('#AddressClassification').val() as string,
        addressType: form.find('#AddressType').val() as string,
        addressUsageType: form.find('#AddressUsageType').val() as string,
        customerNo: form.find('#CustomerNo').val() as string,
        company: form.find('input[id$=Company]').val() as string,
        companyAddition1: form.find('input[id$=Addition1]').val() as string,
        companyAddition2: form.find('input[id$=Addition2]').val() as string,
        leitwegId: form.find('input[id$=LeitwegId]').val() as string,
        eInvoiceId: form.find('input[id$=EInvoiceId]').val() as string,
        eInvoiceEmail: form.find('input[id$=EInvoiceEmail]').val() as string,
        isPublicAuthority: isPublicAuthoritySelected(form.get(0)),
        department: form.find('input[id$=Department]').val() as string,
        salutation:
            (form.find('select[id$=Salutation]').val() as string) ||
            (form.find('input[id$=Salutation]').val() as string),
        title: form.find('select[id$=Title]').val() as string,
        firstName: form.find('input[id$=FirstName]').val() as string,
        middleName: '',
        lastName: form.find('input[id$=LastName]').val() as string,
        streetName: form.find('input[id$=StreetName]').val() as string,
        streetNumber: form.find('input[id$=StreetNumber]').val() as string,
        postalCode: form.find('input[id$=PostalCode]').val() as string,
        city: form.find('input[id$=City]').val() as string,
        country: form.find('select[id$=Country]').val() as string,
        vatNo: form.find('input[id$=VatNo]').val() as string,
        postNo: form.find('input[id$=PostNo]').val() as string,
        packstationNo: form.find('input[id$=PackstationNo]').val() as string,
        postfachNo: form.find('input[id$=PostfachNo]').val() as string,
        postFilialeNo: form.find('input[id$=PostFilialeNo]').val() as string,
        phone: form.find('input[id$=Phone]').val() as string,
        industry: [form.find('input[id$=Industry]').val() as string],
        additionalInfo: form.find('input[id$=AdditionalInfo]').val() as string,
    };
}

function CreatePaymentmethodChange(): IPaymentMethodChange {
    return {
        paymentMethodId: '',
        type: '',
        iban: '',
        bic: '',
        bankName: '',
        accountHolder: '',
        creditCardReferenceNumber: '',
        creditCardCompany: '',
        creditCardValidThru: '',
        creditCardSaferpayAliasId: '',
        paymentSuccessReturnUrl: '',
        paymentErrorReturnUrl: '',
        paymentCancelReturnUrl: '',
    };
}

function fillPaymentMethodSepa(paymentmethodchange: IPaymentMethodChange, form: JQuery) {
    if (!form || form.length == 0) {
        paymentmethodchange;
    }
    paymentmethodchange.accountHolder = form.find('#AccountHolder').val() as string;
    paymentmethodchange.iban = form.find('#Iban').val() as string;
    paymentmethodchange.bic = form.find('#Bic').val() as string;
    paymentmethodchange.type = 'SEPA';
    return paymentmethodchange;
}

function addAddressesToCart(
    billingAddress: IBillingAddress,
    shippingAddress: IShippingAddress,
    emailAddress: string,
    shippingIsBilling: boolean,
    isGuestUser: boolean
) {
    if (submitOngoing) {
        return;
    }
    submitOngoing = true;
    checkoutService
        .AddAddressesToCartGast(billingAddress, shippingAddress, emailAddress, shippingIsBilling, isGuestUser)
        .then(html => {
            addAddressesToCartResultHandling(html);
            submitOngoing = false;
        })
        .catch(html => {
            step1ContentContainer.slideDown('slow', function() {
                spinner.addClass('hide');
                step1ContentContainer.next().show();
            });
            submitOngoing = false;
        })
        .then(() => {
            step1ContentContainer.off();
            registerEvents();
            submitOngoing = false;
        });
}

export function addAddressesToCartResultHandling(html) {
    if (html) {
        overwriteOldForm(step1ContentContainer, html).then(() => {
            step1ContentContainer.slideDown('slow', function() {
                spinner.addClass('hide');
                step1ContentContainer.next().show();
                scrollToFirstError();
            });
        });
    } else {
        window.location.href += '&step2=true';
    }
}

function addPaymentmethodToCart(
    paymentMethod: IPaymentMethodChange,
    isDataUsageAccepted: boolean,
    isGuestUser: boolean
) {
    if (submitOngoing) {
        return;
    }
    submitOngoing = true;
    checkoutService
        .AddPaymentmethodToCartGast(paymentMethod, isDataUsageAccepted, isGuestUser)
        .then(html => {
            if (html) {
                overwriteOldForm(step2ContentContainer, html).then(() => {
                    step2ContentContainer.slideDown('slow', function() {
                        spinner.addClass('hide');
                        step2ContentContainer.next().show();
                        scrollToFirstError();
                    });
                });
            } else {
                window.location.href = '/pruefen-bestellen/';
            }
        })
        .catch(html => {
            console.log('error');
            step2ContentContainer.slideDown('slow', function() {
                spinner.addClass('hide');
                step2ContentContainer.next().show();
            });
        })
        .then(() => {
            console.log('complete');
            step2ContentContainer.off();
            registerEvents();
            submitOngoing = false;
        });
}

function overwriteOldForm(container: JQuery, html: string) {
    return new Promise<void>((resolve, reject) => {
        container.html(html);
        reparseUnobtrusiveValidation(container);
        resolve();
    });
}

/**
 * Parst die jQuery-unobtrusive-Validierung für die per AJAX nachgeladenen Formulare neu.
 * Ohne dies verlieren die ausgetauschten Felder ihre data-val-Regeln und -Meldungen, und
 * jQuery-Validate fällt auf HTML5-Defaults zurück (englische Standardmeldung, keine rote
 * Hervorhebung, Meldung außerhalb des data-valmsg-for-Spans). Analog zu updateValidators()
 * im eingeloggten Checkout (checkoutStep3.ts).
 */
function reparseUnobtrusiveValidation(container: JQuery) {
    const validator: any = ($ as any).validator;
    if (!validator || !validator.unobtrusive) {
        return;
    }
    try {
        container.find('form').removeData('validator').removeData('unobtrusiveValidation');
        validator.unobtrusive.parse(container);
    } catch (e) {
        // Ein Fehler beim Neu-Parsen darf den Re-Render nicht abbrechen — sonst würde das Promise
        // von overwriteOldForm rejecten, der Spinner stehen bleiben und das Formular versteckt
        // bleiben. Client-Validierung ist best-effort; der Server validiert ohnehin.
        // eslint-disable-next-line no-console
        console.error('reparseUnobtrusiveValidation failed', e);
    }
}

function registerEvents() {
    $('#step1ContentContainer .form-action-el, #step2ContentContainer .form-action-el').on('click', function(event) {
        openTab($(this));
    });
    $('#step1ContentContainer .form_bearbeiten button').on('click', function() {
        var formsWrapper = $(this).parents('.forms_wrapper');
        formsWrapper.find('.form_speichern').removeClass('hide');
        formsWrapper.find('.form_bearbeiten_abbrechen').removeClass('hide');
        formsWrapper.find('.form_bearbeiten').addClass('hide');
        formsWrapper.find('.input_form_wrapper').removeClass('disabled-Element');
        $(formsWrapper.find('.input_formRadio')).removeClass('disabled-Element');
    });

    $('#step1ContentContainer .form_bearbeiten_abbrechen').on('click', function() {
        var formsWrapper = $(this).parents('.forms_wrapper');
        formsWrapper.find('.form_speichern').addClass('hide');
        formsWrapper.find('.form_bearbeiten_abbrechen').addClass('hide');
        formsWrapper.find('.form_bearbeiten').removeClass('hide');
        formsWrapper.find('.input_form_wrapper').addClass('disabled-Element');
        var radioButtonArea = $(formsWrapper.find('.input_formRadio'));
        if (radioButtonArea.find('#currentFormIsBusinessForm').val() == 'True') {
            radioButtonArea.find('.input_radioGeschaeftlich').trigger('click');
        } else {
            radioButtonArea.find('.input_radioPrivat').trigger('click');
        }
        radioButtonArea.addClass('disabled-Element');
    });

    //if ($("#InputErrorRechnungsadresseOccured").val() == "geschaeftlich") {
    //    $(".input_formRadioRechnungsadresse .input_radioGeschaeftlich").trigger("click");
    //}

    if ($('#InputErrorLieferadresseOccured').val()) {
        let triggerId = '#formTrigger' + $('#InputErrorLieferadresseType').val();
        let triggerElement = $(triggerId);
        triggerElement
            .trigger('click')
            .find('.acc-trigger')
            .trigger('click');
        if ($('#InputErrorLieferadresseOccured').val() == 'geschaeftlich') {
            triggerElement.find('.input_radioGeschaeftlich').trigger('click');
        } else {
            triggerElement.find('.input_radioPrivat').trigger('click');
        }
        let triggerForm = triggerElement.data('target');
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $(triggerForm).offset().top,
            },
            500
        );
    }

    //if ($("#InputErrorPaymentmethodOccured").val()) {
    //    let triggerId = "#formTrigger" + $("#InputErrorPaymentmethodOccured").val();
    //    let triggerElement = $(triggerId);
    //    triggerElement.trigger("click").find(".acc-trigger").trigger("click");
    //    let triggerForm = triggerElement.data("target");
    //    $([document.documentElement, document.body]).animate({
    //        scrollTop: $(triggerForm).offset().top
    //    }, 500);
    //}

    //Der erste RadioButton im Lieferadressen-Bereich funktioniert nicht mit den anderen, da er in einer Form sitzt. Workaround
    $('#step1ContentContainerinput[type=radio][name=lieferadresse]').on('change', function() {
        $('input[type=radio][name=lieferadresse]:checked')
            .not(this)
            .prop('checked', false);
    });

    //Die RadioButtons für PayPal und Rechnung funktionieren nicht mit den anderen, da sie in einer Form sitzen. Workaround
    $('#step2ContentContainer input[type=radio][name=zahlungsweise]').on('change', function() {
        $('input[type=radio][name=zahlungsweise]:checked')
            .not(this)
            .prop('checked', false);
    });

    $('#step2ContentContainer #DataUsageAccepted').on('change', function() {
        if ($(this).is(':checked')) {
            $('#dataUsageError').addClass('hide');
        }
    });

    //Wechsel zwischen Privat und Geschäftsadresse
    $('#step1ContentContainer input[type=radio].radioButtonAddress').on('change', function() {
        var targetShow = $(this).attr('data-targetShow');
        var targetHide = $(this).attr('data-targetHide');
        $(targetHide).addClass('hide');
        $(targetShow).removeClass('hide');

        // "geschäftlich" und "öffentlicher Auftraggeber" tragen beide data-publicauthority und
        // sind damit Business-Varianten; nur "privat" trägt das Attribut nicht.
        var publicAuthorityAttr = $(this).attr('data-publicauthority');
        var isBusiness = publicAuthorityAttr !== undefined;

        if (isBusiness) {
            $('.lieferBusiness').removeClass('hide');
            $('.lieferPrivat,#formTriggerPackstation,#formTriggerPostfiliale').addClass('hide');
            $('#shippingAddressContainerGast .input_radioGeschaeftlich').prop('checked', true);
            // data-targetShow ist immer ein ID-Selektor (z.B. "#rechnungsadresseGeschaeftlichForm").
            var businessContainer = targetShow ? document.getElementById(targetShow.replace(/^#/, '')) : null;
            var businessForm = (businessContainer && businessContainer.querySelector('form')) || businessContainer;
            applyLeitwegIdState(businessForm, publicAuthorityAttr === 'true');
        } else {
            $('.lieferBusiness').addClass('hide');
            $('.lieferPrivat,#formTriggerPackstation,#formTriggerPostfiliale').removeClass('hide');
            $('#shippingAddressContainerGast .input_radioPrivat').prop('checked', true);
        }
    });

    //Beim Laden den initial gewählten Rechnungsadresse-Radio auswerten, damit nach einem
    //Validierungsfehler (Re-Render mit vorausgewähltem "öffentlicher Auftraggeber") Pflichtfeld-
    //Stern und Sichtbarkeit konsistent mit dem von Razor gerenderten Initialzustand sind.
    var initialBillingRadio = $(
        '#step1ContentContainer #formRechnungsadresse input[type=radio].radioButtonAddress:checked'
    );
    var initialPublicAuthorityAttr = initialBillingRadio.attr('data-publicauthority');
    if (initialBillingRadio.length && initialPublicAuthorityAttr !== undefined) {
        var initialTargetShow = initialBillingRadio.attr('data-targetShow');
        var initialContainer = initialTargetShow ? document.getElementById(initialTargetShow.replace(/^#/, '')) : null;
        var initialBusinessForm = (initialContainer && initialContainer.querySelector('form')) || initialContainer;
        applyLeitwegIdState(initialBusinessForm, initialPublicAuthorityAttr === 'true');
    }

    //Unter geschäftlichen Rechnungsadressen dürfen private Lieferadressen angelegt werden, umgekehrt nicht.
    $('#step1ContentContainer #formRechnungsadresse .radioButtonAddress').on('click', function() {
        if ($(this).hasClass('input_radioPrivat')) {
            $('#formLieferadresse .input_formRadio').addClass('disabled-Element');
        }
        if ($(this).hasClass('input_radioGeschaeftlich') || $(this).hasClass('input_radioOeffentlicherAuftraggeber')) {
            $('#formLieferadresse .input_formRadio').removeClass('disabled-Element');
        }
    });
    //Blendet wenn ein Land mit dem Eintrag "ShowVAT" ausgewählt wird das VAT-Feld ein
    $('#step1ContentContainer .CountryListGeschaeftlich').on('change', function() {
        var showVat = $(this)
            .find('option:selected')
            .data('showvat');
        if (showVat === 'True') {
            $('#VATEntry').removeClass('hide');
        } else {
            $('#VATEntry').addClass('hide');
        }

        //Leitweg-ID-Pflichtfeldstatus neu bewerten — nur für DE Pflicht. Land-Select und
        //Leitweg-ID-Zeile liegen in derselben Form; aktueller Zustand steht im Hidden-Field.
        var businessForm = $(this).closest('form').get(0);
        applyLeitwegIdState(businessForm, isPublicAuthoritySelected(businessForm));
    });

    $('.accordion-header.acc-trigger').on('click', function() {
        $(this)
            .find('input[type=radio]')
            .prop('checked', true);

        $('#rechnungsadressePrivatForm .input_FirstName').trigger('change');
        $('#rechnungsadressePrivatForm .input_LastName').trigger('change');

        $('#rechnungsadressePrivatForm .input_Salutation').trigger('change');
    });

    $('.acc-trigger.openOnLoad').trigger('click');
}

function openTab(tab: JQuery) {
    $('.hide_ifFormOpen').addClass('hide');
    $('.hide_ifNotNew').removeClass('hide');
    $('.show_ifNotNew').addClass('hide');
    var dataID = tab.attr('data-target');
    $(dataID)
        .addClass('form-active')
        .slideDown(500);
}

function scrollTo(classOrElement, duration?: number) {
    let element = $(classOrElement);
    if (element.length > 0) {
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $(element).offset().top - 30,
            },
            duration ? duration : 1000
        );
    }
}
